import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';
import SimpleContentMixin from './simple-content-mixin';
import { deviceBenchmark } from 'utils/device-benchmark';

import './index.scss';

@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
@componentMixin(SimpleContentMixin)
class SimpleContentBase extends Component {
    props = {};

    options = {};

    async onSetup() {}
}

export default SimpleContentBase;
